<form [formGroup]="form" class="space-y-6" (ngSubmit)="onSubmit()">
  <!-- Business Name -->
  <div>
    <label for="name" class="block text-sm font-medium text-gray-700 mb-2">
      Nome Attività <span class="text-red-500">*</span>
    </label>
    <div class="relative">
      <input
        type="text"
        id="name"
        formControlName="name"
        class="block w-full rounded-lg border-gray-300 shadow-sm focus:border-primary focus:ring-primary text-base transition-colors"
        [ngClass]="{'border-red-300': form.get('name')?.invalid && form.get('name')?.touched}"
      >
      @if (form.get('name')?.invalid && form.get('name')?.touched) {
        <div class="absolute inset-y-0 right-0 flex items-center pr-3">
          <svg class="h-5 w-5 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
      }
    </div>
    @if (form.get('name')?.invalid && form.get('name')?.touched) {
      <p class="mt-2 text-sm text-red-600">Nome attività richiesto</p>
    }
  </div>

  <!-- Email -->
  <div>
    <label for="email" class="block text-sm font-medium text-gray-700 mb-2">
      Email <span class="text-red-500">*</span>
    </label>
    <div class="relative">
      <input
        type="email"
        id="email"
        formControlName="email"
        class="block w-full rounded-lg border-gray-300 shadow-sm focus:border-primary focus:ring-primary text-base transition-colors"
        [ngClass]="{'border-red-300': form.get('email')?.invalid && form.get('email')?.touched}"
      >
      @if (form.get('email')?.invalid && form.get('email')?.touched) {
        <div class="absolute inset-y-0 right-0 flex items-center pr-3">
          <svg class="h-5 w-5 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
      }
    </div>
    @if (form.get('email')?.invalid && form.get('email')?.touched) {
      <p class="mt-2 text-sm text-red-600">
        @if (form.get('email')?.errors?.['required']) {
          Email richiesta
        } @else if (form.get('email')?.errors?.['email']) {
          Email non valida
        }
      </p>
    }
  </div>

  <!-- Password -->
  <div>
    <label for="password" class="block text-sm font-medium text-gray-700 mb-2">
      Password <span class="text-red-500">*</span>
    </label>
    <div class="relative flex gap-2">
      <div class="relative flex-1">
        <input
          [type]="showPassword ? 'text' : 'password'"
          id="password"
          formControlName="password"
          class="block w-full rounded-lg border-gray-300 shadow-sm focus:border-primary focus:ring-primary text-base transition-colors pr-10"
          [ngClass]="{'border-red-300': form.get('password')?.invalid && form.get('password')?.touched}"
        >
        <button
          type="button"
          (click)="togglePasswordVisibility()"
          class="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 hover:text-gray-600"
        >
          @if (showPassword) {
            <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
            </svg>
          } @else {
            <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
            </svg>
          }
        </button>
      </div>
      <button
        type="button"
        (click)="generatePassword()"
        class="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-lg text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary transition-all"
        title="Genera password casuale"
      >
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
        </svg>
      </button>
    </div>
    @if (form.get('password')?.invalid && form.get('password')?.touched) {
      <p class="mt-2 text-sm text-red-600">Password richiesta</p>
    }
  </div>
  <div class="mt-6 flex justify-end">
    <button
      type="submit"
      class="inline-flex items-center px-6 py-2.5 border border-transparent text-base font-medium rounded-lg shadow-sm text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-600 transition-all"
    >
      <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
      </svg>
      Salva utente
    </button>
  </div>
</form>